import HeroFullScreenImage from "./HeroFullScreenImage";

export default HeroFullScreenImage;
